"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientId = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _axios = _interopRequireDefault(require("axios"));
var _createHash = _interopRequireDefault(require("create-hash"));
var _queryString = _interopRequireDefault(require("query-string"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../ApplicationContext");
var _SecurityContext = _interopRequireDefault(require("../SecurityContext"));
var _SecurityContextHolder = require("../SecurityContextHolder");
var _MessageResolver = require("../MessageResolver");
var _Step = _interopRequireDefault(require("./Step"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const processSuccessfulAuthentication = (controller, listener) => {
  const {
    returnUrl: returnUrlState
  } = listener.props?.location?.state ? listener.props?.location?.state : {
    returnUrl: '/protected.html'
  };
  const {
    returnUrl: returnUrlSearch
  } = _queryString.default.parse(listener.props?.location?.search ? listener.props?.location?.search : {
    returnUrl: '/protected.html'
  });
  const stepResponse = controller.getStepResponse();
  if (stepResponse.accessCode && stepResponse.redirectUri) {
    _SecurityContextHolder.SecurityContextHolder.reset();
    _ApplicationContext.ApplicationContext.clearContext();
    var url = `${stepResponse.redirectUri}?code=${stepResponse.accessCode}`;
    if (stepResponse.state) {
      url = `${url}&state=${stepResponse.state}`;
    }
    window.location.href = url;
    return;
  }
  const securityContext = _SecurityContext.default.from(stepResponse.profile);
  const menu = {
    menuItems: [stepResponse.siteMenu]
  };
  securityContext.contextId = controller.getCodeVerifier();
  securityContext.setRefreshToken(stepResponse);
  securityContext.setMenu(menu);
  securityContext.setAdditionalData({
    ...stepResponse.profile.additionalData,
    ...stepResponse.additionalData
  });
  const targetOrigins = _core.PostMessage.getRegisteredTargetOrigins();
  let returnUrl = returnUrlSearch || returnUrlState || '/protected.html';
  if (returnUrl === _ApplicationContext.ApplicationContext.getLoginPath() || !_ApplicationContext.ApplicationContext.isReturnUrl()) {
    returnUrl = '/protected.html';
  }
  _SecurityContextHolder.SecurityContextHolder.reset();
  _ApplicationContext.ApplicationContext.clearContext();
  _ApplicationContext.ApplicationContext.setDataSource(stepResponse?.additionalData?.datasource);
  _SecurityContextHolder.SecurityContextHolder.setCurrentContext(securityContext);
  _core.PostMessage.registerTargetOrigins(targetOrigins);
  _core.PostMessage.postMessageCoreSuccess('Authenticated', {});
  listener.props.history.push(returnUrl);
};
const getClientId = (isFromMarketingRep, isFromSuperUser) => {
  if (isFromMarketingRep) {
    return `${_ApplicationContext.ApplicationContext.getClientId()}-marketingrep`;
  }
  if (isFromSuperUser) {
    return `${_ApplicationContext.ApplicationContext.getClientId()}-runas`;
  }
  return _ApplicationContext.ApplicationContext.getClientId();
};
exports.getClientId = getClientId;
const processResults = (listener, stepListener, controller) => {
  /**
   * 1. If there is a failure, let the main Login page know
   * 2. If it is successful/complete authentication, let the main login page know
   * 3. If the step was successful, let the main login page know the next step
   * 4. If the step had an error, let the step handler know the error message
   */

  if (controller.isFailure()) {
    listener.setState({
      showFramework: true
    });
    controller.clearState();
    listener.setState({
      authFailure: true,
      statusCode: controller.getStatusCode(),
      message: controller.getMessage()
    });
  } else if (controller.isComplete()) {
    listener.setState({
      showFramework: true
    });
    controller.clearState();
    processSuccessfulAuthentication(controller, listener);
  } else if (controller.wasStepSuccessful()) {
    controller.updateState();
    // eslint-disable-next-line no-console
    listener.setState({
      authComponent: controller.getNextStep(),
      stepResponse: controller.getStepResponse()
    });
    if (controller.getNextStep() === 'AzureAuthenticationStep') {
      _ApplicationContext.ApplicationContext.showFramework(false);
      listener.setState({
        showFramework: false
      });
    }
  } else {
    controller.updateState();
    const errorMessage = /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-1 icon is-right has-text-warning"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons is-size-1"
    }, "warning")), /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-11 "
    }, /*#__PURE__*/_react.default.createElement(_MessageResolver.MessageResolver, {
      statusCode: controller.getStatusCode(),
      message: controller.getMessage()
    })));
    stepListener.setState({
      errorMessage,
      rawErrorMessage: controller.getMessage(),
      isLoading: false,
      additionalData: controller.getStepResponse()?.additionalData
    });
  }
};
var _request = /*#__PURE__*/new WeakMap();
var _listener = /*#__PURE__*/new WeakMap();
var _codeVerifier = /*#__PURE__*/new WeakMap();
var _stepResponse = /*#__PURE__*/new WeakMap();
class AuthenticationController {
  constructor(listener) {
    let loadState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classPrivateFieldInitSpec(this, _request, null);
    _classPrivateFieldInitSpec(this, _listener, null);
    _classPrivateFieldInitSpec(this, _codeVerifier, null);
    _classPrivateFieldInitSpec(this, _stepResponse, null);
    _classPrivateFieldSet(_listener, this, listener);
    if (loadState) {
      _classPrivateFieldSet(_codeVerifier, this, _ApplicationContext.ApplicationContext.getContext('login.state.codeVerifier'));
      const json = _ApplicationContext.ApplicationContext.getContext('login.state.stepResponse');
      try {
        if (typeof json === 'string') {
          _classPrivateFieldSet(_stepResponse, this, Object.assign(new _Step.default(), JSON.parse(json)));
        }
      } catch (e) {
        _classPrivateFieldSet(_codeVerifier, this, null);
      }
    }
    _classPrivateFieldSet(_request, this, _axios.default.create({
      withCredentials: true,
      baseURL: _ApplicationContext.ApplicationContext.getApiBasePath()
    }));
  }
  clearState() {
    _ApplicationContext.ApplicationContext.setContext('login.state.codeVerifier', null);
    _ApplicationContext.ApplicationContext.setContext('login.state.stepResponse', null);
  }
  updateState() {
    _ApplicationContext.ApplicationContext.setContext('login.state.stepResponse', JSON.stringify(_classPrivateFieldGet(_stepResponse, this)));
    _ApplicationContext.ApplicationContext.setContext('login.state.authComponent', this.getNextStep());
  }
  initialize(stepListener, isFromSuperUser, isFromMarketingRep) {
    const currentChallengeUUID = (0, _uuid.v4)();
    _classPrivateFieldSet(_codeVerifier, this, (0, _createHash.default)('sha256').update(currentChallengeUUID).digest('base64'));
    _ApplicationContext.ApplicationContext.setContext('login.state.codeVerifier', _classPrivateFieldGet(_codeVerifier, this));
    const formData = new FormData();
    formData.append('client_id', getClientId(isFromMarketingRep, isFromSuperUser));
    formData.append('code_challenge', currentChallengeUUID);
    formData.append('code_challenge_method', 'S256');
    _classPrivateFieldGet(_request, this).post('/security/auth/initialize', formData).then(results => {
      _classPrivateFieldSet(_stepResponse, this, results.data);
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    }).catch(() => {
      _classPrivateFieldSet(_stepResponse, this, {
        message: 'Unable to perform authentication at this time.  Please try again later.',
        stepStatus: 'FAILED',
        workflowStatus: 'FAILED'
      });
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    });
  }
  proceed(stepListener, step) {
    step.setCodeVerifier(_classPrivateFieldGet(_codeVerifier, this));
    step.setContextId(_classPrivateFieldGet(_stepResponse, this).contextId);
    _classPrivateFieldGet(_request, this).post('/security/auth/continue', step).then(results => {
      _classPrivateFieldSet(_stepResponse, this, results.data);
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    }).catch(() => {
      _classPrivateFieldSet(_stepResponse, this, {
        message: 'Unable to perform authentication at this time.  Please try again later.',
        stepStatus: 'FAILED',
        workflowStatus: 'FAILED'
      });
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    });
  }
  getCodeVerifier() {
    return _classPrivateFieldGet(_codeVerifier, this);
  }
  isFailure() {
    const isFailure = _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).workflowStatus === 'FAILED' : false;
    return isFailure;
  }
  isComplete() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).workflowComplete : false;
  }
  wasStepSuccessful() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).stepSuccessful : false;
  }
  getNextStep() {
    if (_ApplicationContext.ApplicationContext.getAzureApplicationId()) {
      // Use session storage to determine next step in workflows that need persistance between page loads
      const ctxNextStep = _ApplicationContext.ApplicationContext.getContext('login.state.authComponent');
      if (typeof ctxNextStep === 'string') {
        return ctxNextStep;
      }
    }
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).nextStep : 'InitializeAuthentication';
  }
  getMessage() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).message : null;
  }
  getStatusCode() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).statusCode : null;
  }
  getAdditionalData() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).additionalData : null;
  }
  getStepResponse() {
    return _classPrivateFieldGet(_stepResponse, this);
  }
}
var _default = exports.default = AuthenticationController;
//# sourceMappingURL=AuthenticationController.js.map